class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this._boundOnCartUpdated = this._onCartUpdated.bind(this);
    document.documentElement.addEventListener("cart:updated", this._boundOnCartUpdated);
  }

  disconnectedCallback() {
    document.documentElement.removeEventListener("cart:updated", this._boundOnCartUpdated);
  }

  get threshold() {
    const val = parseFloat(this.getAttribute("threshold"));
    return isNaN(val) ? 0 : val;
  }

  _onCartUpdated(event) {
    const cart = event.detail.cart || {};
    const items = Array.isArray(cart.items) ? cart.items : [];

    const totalPrice = items.reduce((sum, item) => {
      const price = parseFloat(item.price || 0);
      const qty = parseInt(item.quantity || 0, 10);
      return sum + price * qty;
    }, 0);

    const progress = this.threshold > 0 ? Math.min(totalPrice / this.threshold, 1) : 0;
    this.style.setProperty("--progress", progress);

    const textEl = this.querySelector(".shipping-bar__text");
    if (textEl) {
      if (totalPrice >= this.threshold) {
        textEl.textContent = "Free shipping unlocked";
      } else {
        const remaining = this.threshold - totalPrice;
        textEl.textContent = `Add ${window.Shopify ? Shopify.formatMoney(remaining) : remaining} more for free shipping in Peninsular Malaysia`;
      }
    }
  }
}

customElements.define("free-shipping-bar", FreeShippingBar);
